export default {
    discount: {},
    discounts: []
}